module.exports = __webpack_public_path__ + "img/Marca DB DO negatiu quadrat.dcfca684.png";